import React from 'react';

interface TrialActiveIconProps {
  width?: number;
  height?: number;
  className?: string;
}

/**
 * Trial Active Icon with gradient effect
 * Used to indicate active trial status with purple to blue gradient
 */
const TrialActiveIcon: React.FC<TrialActiveIconProps> = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.79688 2.5H7.20312V0H8.70312V2.5H8.79688ZM0 9H2.20312V7.5H0V9ZM13.7969 7.5V9H16V7.5H13.7969ZM2.90625 1.79688L1.79688 2.90625L3.20312 4.29688L4.29688 3.20312L2.90625 1.79688ZM13.0938 1.79688L11.7031 3.20312L12.7969 4.29688L14.2031 2.90625L13.0938 1.79688ZM12.2031 6.5C12.5052 7.07292 12.6823 7.67188 12.7344 8.29688C12.7865 8.92188 12.7292 9.52604 12.5625 10.1094C12.3958 10.6927 12.1198 11.2292 11.7344 11.7188C11.349 12.2083 10.8698 12.6042 10.2969 12.9062V16H5.79688V12.9062C5.40104 12.6979 5.03646 12.4271 4.70312 12.0938C4.36979 11.7604 4.10417 11.3958 3.90625 11C3.57292 10.4271 3.375 9.82812 3.3125 9.20312C3.23958 8.57812 3.28125 7.97396 3.4375 7.39062C3.60417 6.80729 3.88021 6.27083 4.26562 5.78125C4.65104 5.29167 5.13021 4.89583 5.70312 4.59375C6.27604 4.27083 6.875 4.08333 7.5 4.03125C8.125 3.96875 8.72917 4.02604 9.3125 4.20312C9.90625 4.38021 10.4531 4.66146 10.9531 5.04688C11.4635 5.44271 11.8802 5.92708 12.2031 6.5ZM9.5 5.79688C9.125 5.59896 8.72917 5.48438 8.3125 5.45312C7.88542 5.42188 7.46875 5.46875 7.0625 5.59375C6.66667 5.71875 6.29688 5.91667 5.95312 6.1875C5.60938 6.45833 5.32292 6.79688 5.09375 7.20312C4.875 7.59896 4.74479 8.01562 4.70312 8.45312C4.66146 8.88021 4.69792 9.29688 4.8125 9.70312C4.92708 10.099 5.11979 10.4635 5.39062 10.7969C5.66146 11.1302 6 11.3958 6.40625 11.5938L7.20312 12V14.5H8.70312V12L9.5 11.5938C9.80208 11.4479 10.0573 11.2604 10.2656 11.0312C10.474 10.7917 10.651 10.5469 10.7969 10.2969C11.026 9.90104 11.1615 9.48438 11.2031 9.04688C11.2448 8.60938 11.2031 8.1875 11.0781 7.78125C10.9635 7.375 10.7708 7 10.5 6.65625C10.2292 6.3125 9.89583 6.02604 9.5 5.79688Z"
        fill="url(#paint0_linear_2005_64070)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2005_64070"
          x1="-1.13621e-07"
          y1="15.9999"
          x2="16.0256"
          y2="15.9743"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#8F41E9" />
          <stop offset="1" stop-color="#578AEF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default TrialActiveIcon;
